<template>
  <div class="dropdown" @mouseleave="closeDropdown">
    <!-- Le texte "Produits" redirige directement vers la page produits -->
    <router-link to="/produits" class="dropdown-text" @click="closeDropdown">Produits</router-link>
    
    <!-- L'icône permet de basculer le menu déroulant -->
    <button @click.stop="toggleDropdown" class="dropdown-toggle" aria-label="Menu produits">
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2.5" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        :class="{ 'rotated': isDropdownOpen }"
      >
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </button>

    <!-- Menu déroulant -->
    <transition name="dropdown">
      <ul v-if="isDropdownOpen" class="dropdown-menu"> 
        <li @click="closeDropdown">
          <router-link to="/equipementlabo">
            Équipement Labo
          </router-link>
        </li>
        <li @click="closeDropdown">
          <router-link to="/consomablesComp">
            Consommable
          </router-link>
        </li>
        <li @click="closeDropdown">
          <router-link to="/reactifs">
           Réactifs
          </router-link>
        </li>
        <li @click="closeDropdown">
          <router-link to="/bacteriologie">
           Bactériologie
          </router-link>
        </li>
        <li @click="closeDropdown">
          <router-link to="/chimiques">
            Chimiques
          </router-link>
        </li>
        <li @click="closeDropdown">
          <router-link to="/vitamines-mineraux">
           Vitamines & Minéraux
          </router-link>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DropdownComponent",
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation();
      this.isDropdownOpen = !this.isDropdownOpen;
      console.log("Dropdown ouvert ?", this.isDropdownOpen);
    },
    closeDropdown() {
      this.isDropdownOpen = false;
      console.log("Dropdown fermé");
    },
  },
};
</script>

<style scoped>
:root {
  --brand: #00998B;
  --brand-dark: #05305b;
  --ink: #1a1a2e;
  --gray: #6c7a89;
  --light-bg: #f7f9fc;
  --border: #edf2f7;
}



/* Wrapper */
.dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 100%;
}

/* Lien trigger */
.dropdown-text {
  display: inline-flex;
  align-items: center;
  color: var(--ink);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 8px 2px;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  transition: color 0.15s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.dropdown-text::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2.5px;
  width: 0%;
  background: var(--brand);
  border-radius: 2px;
  transition: width 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.dropdown:hover .dropdown-text::after {
  width: 100%;
}

.dropdown-text:hover {
  color: var(--brand);
}

/* Chevron / Icône */
.dropdown-toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: var(--ink);
  transition: all 0.25s ease;
  border-radius: 6px;
  width: 28px;
  height: 28px;
}

.dropdown-toggle:hover {
  background: var(--light-bg);
  color: var(--brand);
}

.dropdown-toggle svg {
  stroke: currentColor;
  transition: transform 0.3s ease;
}

.dropdown-toggle svg.rotated {
  transform: rotate(180deg);
}

/* Panneau (flottant) */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 240px;
  max-width: 320px;
  background: #ffffff;
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  padding: 8px;
  margin: 0;
  list-style: none;
  z-index: 1001;
}

/* Petit caret */
.dropdown-menu::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-left: 1px solid var(--border);
  border-top: 1px solid var(--border);
}

/* Items */
.dropdown-menu li {
  border-radius: 10px;
  overflow: hidden;
}

.dropdown-menu li a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  color: var(--ink);
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
}

.dropdown-menu li a:hover {
  background: var(--light-bg);
  color: var(--brand);
  transform: translateX(4px);
}

.menu-icon {
  font-size: 16px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

/* --- Transition --- */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.25s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px);
}

/* ============================================
   RESPONSIVE : SIDEBAR
   ============================================ */
@media (max-width: 1040px) {
  .dropdown {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown-text {
    padding: 12px 6px;
    flex: 1;
  }

  .dropdown-text::after {
    display: none;
  }

  .dropdown-menu {
    position: static;
    transform: none;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    margin-top: 6px;
    border-radius: 12px;
    box-shadow: none;
    border: 1px solid var(--border);
    background: var(--light-bg);
  }

  .dropdown-menu::before {
    display: none;
  }

  .dropdown-menu li a {
    padding: 8px 14px;
    font-size: 13px;
  }

  .dropdown-menu li a:hover {
    transform: none;
  }

  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.2s ease;
  }

  .dropdown-enter-from,
  .dropdown-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
}

/* ============================================
   MODE SOMBRE
   ============================================ */
@media (prefers-color-scheme: dark) {
  .dropdown-text {
    color: #e6edf1;
  }

  .dropdown-text::after {
    background: #4ade80;
  }

  .dropdown-text:hover {
    color: #4ade80;
  }

  .dropdown-toggle {
    color: #8b97a3;
  }

  .dropdown-toggle:hover {
    background: #1a2532;
    color: #4ade80;
  }

  .dropdown-menu {
    background: #1a2532;
    border-color: #2a3645;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
  }

  .dropdown-menu::before {
    background: #1a2532;
    border-color: #2a3645;
  }

  .dropdown-menu li a {
    color: #8b97a3;
  }

  .dropdown-menu li a:hover {
    background: #0f1720;
    color: #4ade80;
  }
}

/* ============================================
   SURVOL DESKTOP (optionnel)
   ============================================ */
@media (min-width: 1041px) {
  .dropdown:hover .dropdown-menu {
    display: block;
  }
  
  /* Empêcher l'affichage du hover si dropdown est fermé */
  .dropdown:not(:hover) .dropdown-menu {
    display: none;
  }
}
</style>